var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bc-user-search-item-skeleton bcx-skeleton-areas"},[_c('div',{staticClass:"c-avatar"}),_c('div',{staticClass:"c-item"}),_c('div',{staticClass:"c-item"}),_c('div',{staticClass:"c-item"}),_c('div',{staticClass:"c-item"}),_c('div',{staticClass:"c-item"})])
}]

export { render, staticRenderFns }